import DOMPurify from 'isomorphic-dompurify';
import { Parser } from 'html-to-react';

export default function sanitize(html: string) {
  const cleanHtml = DOMPurify.sanitize(html, { ALLOWED_TAGS: ['a'] });
  const htmlToReactParser = new Parser();
  return htmlToReactParser.parse(cleanHtml);
}
